<template>
  <div class="keyVisualWrapper" :style="styles">
    <div :class="{'container': !noContainer}">
      <div :class="{'row':addRow}">
        <img class="desktop_img img-fluid w-100" :src="$t('desktopBanner')" alt="banner" />
        <img class="tablet_img img-fluid w-100" :src="$t('tabletBanner')" alt="banner" :style="tabletImgStyles" />
        <img class="mobile_img img-fluid w-100" :src="$t('mobileBanner')" alt="banner" :style="mobileImgStyles" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "key-visual",
  props: {
    desktopImageUrl: {
      type: String
    },
    mobileImageUrl: {
      type: String
    },
    tabletImageUrl: {
      type: String
    },
    addRow: {
      type: Boolean
    },
    noContainer: {
      type: Boolean
    },
    mobileImgStyles: {
      type: Object,
      default: () => {}
    },
    tabletImgStyles: {
      type: Object,
      default: () => {}
    },
    styles: {
      type: Object,
      default: () => {}
    }
  }
};
</script>

<style scoped lang="scss">
  .keyVisualWrapper {
    position: relative;
  }

.desktop_img {
  @media (max-width: 768px) {
    display: none;
  }
}

.tablet_img {
  @media (max-width: 435px), (min-width: 769px) {
    display: none;
  }
}

.mobile_img {
  @media (min-width: 436px) {
    display: none;
  }
}

</style>
